import {UserType} from 'api/dataTypes';
import classNames from 'classnames';
import {ModalSignInForm} from 'containers/ModalSignInForm/ModalSignInForm';
import {getUserName} from 'lib/getters';
import {useCartAuthPanel} from 'modules/Cart/containers/CartAuthPanel/useCartAuthPanel';
import {FC} from 'react';

import {Button, ButtonSize} from 'components/Button/Button';
import {Text} from 'components/Text/Text';

import styles from './CartAuthPanel.module.css';

const PROGRESS_ORDER_CLASSES: Record<number, string> = {
    1: styles.progress1,
    2: styles.progress2,
    3: styles.progress3,
    4: styles.progress4,
    5: styles.progress5,
    6: styles.progress6,
    7: styles.progress7,
};

type Props = {
    className?: string;
};
export const CartAuthPanel: FC<Props> = ({className}) => {
    const {
        currentLevel,
        authModalIsVisible,
        toggleAuthModal,
        handleSignInSuccess,
        currentUser,
        isLoading,
    } = useCartAuthPanel();

    const userIsLegal = currentUser?.type === UserType.Legal;

    if (isLoading) {
        return (
            <div className={classNames(styles.blockPlaceholder, className)} />
        );
    }

    if (currentUser) {
        return (
            <div
                className={classNames(styles.block, className, styles.withAuth)}
            >
                <div className={styles.content}>
                    <div className={styles.userInfo}>
                        <Text.Bold14 className={styles.userName}>
                            {userIsLegal
                                ? currentUser.legal
                                : getUserName(currentUser.member)}
                        </Text.Bold14>
                        {userIsLegal && (
                            <Text.Regular12
                                className={classNames(styles.inn, {
                                    [styles.inn12]:
                                        currentUser?.inn.length === 12,
                                })}
                            >
                                ИНН: {currentUser?.inn}
                            </Text.Regular12>
                        )}
                    </div>
                    <div className={styles.discount}>
                        <Text.Regular14>Ваша скидка:</Text.Regular14>
                        <Text.Bold14>Уровень {currentLevel}</Text.Bold14>
                        <div className={styles.progress}>
                            {[1, 2, 3, 4, 5, 6, 7].map((item, index) => {
                                const isActive = item <= currentLevel;

                                return (
                                    <div
                                        key={index}
                                        className={classNames(
                                            styles.progressItem,
                                            PROGRESS_ORDER_CLASSES[index + 1],
                                            {
                                                [styles.active]: isActive,
                                            },
                                        )}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.content}>
                <span className={styles.textAuth}>
                    Авторизуйтесь, <br className={styles.authTextSpacer} />
                    будет больше скидок!
                </span>
                <div className={styles.authButton}>
                    <Button size={ButtonSize.XS} onClick={toggleAuthModal}>
                        Авторизоваться
                    </Button>
                </div>
            </div>
            <div className={styles.bgAuth}></div>
            <ModalSignInForm
                visible={authModalIsVisible}
                onClose={toggleAuthModal}
                onSignInSuccess={handleSignInSuccess}
            />
        </div>
    );
};
